// View Component: Navbar bileşeni
import React from "react";
import Button from "../UI/Button";
import {
  useNavbarVisibility,
  useSmoothScroll,
} from "../../hooks/useLandingPage";
import { AppConstants } from "../../models/AppData";

const Navbar = () => {
  const isScrolled = useNavbarVisibility();
  const scrollToSection = useSmoothScroll();

  const navbarStyles = {
    position: "fixed",
    top: "0",
    left: "0",
    right: "0",
    zIndex: "1000",
    backgroundColor: isScrolled ? "rgba(255, 255, 255, 0.95)" : "transparent",
    backdropFilter: isScrolled ? "blur(20px)" : "none",
    borderBottom: isScrolled ? "1px solid rgba(229, 231, 235, 0.5)" : "none",
    transition: "all 300ms cubic-bezier(0.4, 0, 0.2, 1)",
    padding: "var(--spacing-lg) 0",
  };

  const containerStyles = {
    maxWidth: "1200px",
    margin: "0 auto",
    padding: "0 var(--spacing-lg)",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  };

  const logoStyles = {
    display: "flex",
    alignItems: "center",
    gap: "var(--spacing-md)",
    fontSize: "24px",
    fontWeight: "700",
    fontFamily: "var(--font-secondary)",
    color: isScrolled ? "var(--gray-900)" : "var(--gray-900)",
    cursor: "pointer",
    transition: "color 300ms ease",
  };

  const logoIconStyles = {
    fontSize: "32px",
  };

  const navigationStyles = {
    display: "flex",
    alignItems: "center",
    gap: "var(--spacing-3xl)",
    listStyle: "none",
  };

  const navLinkStyles = {
    fontSize: "16px",
    fontWeight: "500",
    color: isScrolled ? "var(--gray-700)" : "var(--gray-700)",
    cursor: "pointer",
    transition: "color 300ms ease",
    textDecoration: "none",
  };

  const mobileMenuStyles = {
    display: "none",
  };

  const mediaQuery = window.matchMedia("(max-width: 768px)");
  const isMobile = mediaQuery.matches;

  const responsiveNavigationStyles = isMobile
    ? {
        display: "none",
      }
    : navigationStyles;

  const responsiveMobileMenuStyles = isMobile
    ? {
        display: "block",
      }
    : mobileMenuStyles;

  const handleLinkHover = (e) => {
    e.target.style.color = "var(--color-primary)";
  };

  const handleLinkLeave = (e) => {
    e.target.style.color = isScrolled ? "var(--gray-700)" : "var(--gray-700)";
  };

  const handleLogoClick = () => {
    scrollToSection("home");
  };

  return (
    <nav style={navbarStyles}>
      <div style={containerStyles}>
        {/* Logo */}
        <div style={logoStyles} onClick={handleLogoClick}>
          <img
            src="/logo512.png"
            alt="Inbox Zero Logo"
            style={{
              width: "32px",
              height: "32px",
              objectFit: "contain",
              transition: "transform 0.2s ease",
            }}
            onError={(e) => {
              // Fallback to emoji if logo doesn't exist
              e.target.style.display = "none";
              e.target.nextSibling.style.display = "inline";
            }}
            onMouseEnter={(e) => {
              e.target.style.transform = "scale(1.1)";
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = "scale(1)";
            }}
          />
          <span style={{ ...logoIconStyles, display: "none" }}>🧠</span>
          <span>Inbox Zero</span>
        </div>

        {/* Desktop Navigation */}
        <ul style={responsiveNavigationStyles}>
          <li>
            <a
              style={navLinkStyles}
              onClick={() => scrollToSection("home")}
              onMouseEnter={handleLinkHover}
              onMouseLeave={handleLinkLeave}
            >
              Home
            </a>
          </li>
          <li>
            <a
              style={navLinkStyles}
              onClick={() => scrollToSection("features")}
              onMouseEnter={handleLinkHover}
              onMouseLeave={handleLinkLeave}
            >
              Features
            </a>
          </li>
          <li>
            <a
              style={navLinkStyles}
              onClick={() => scrollToSection("testimonials")}
              onMouseEnter={handleLinkHover}
              onMouseLeave={handleLinkLeave}
            >
              Testimonials
            </a>
          </li>
          <li>
            <a
              style={navLinkStyles}
              onClick={() => scrollToSection("faq")}
              onMouseEnter={handleLinkHover}
              onMouseLeave={handleLinkLeave}
            >
              FAQ
            </a>
          </li>
        </ul>

        {/* CTA Button */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "var(--spacing-md)",
          }}
        >
          <Button
            variant="primary"
            size="medium"
            onClick={() =>
              window.open(
                "https://apps.apple.com/us/app/inbox-zero-ai-mail-coach/id6747061594",
                "_blank"
              )
            }
            icon="🚀"
          >
            Get Started
          </Button>

          {/* Mobile Menu Button */}
          <div style={responsiveMobileMenuStyles}>
            <Button
              variant="secondary"
              size="medium"
              onClick={() => {
                // TODO: Mobile menu toggle functionality
                console.log("Mobile menu toggled");
              }}
              icon="☰"
            ></Button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
